module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [(_vm.valueType == 'ListSerializer') ? _vm._l((_vm.value), function(item, $index) {
    return _c('table-cell-inner', {
      key: $index,
      attrs: {
        "value": item,
        "valueType": _vm.childValueType
      }
    })
  }) : _c('table-cell-inner', {
    attrs: {
      "value": _vm.value,
      "valueType": _vm.valueType
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04a0f266"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/TableCell.vue
// module id = 607
// module chunks = 0